(function(){
'use strict';
if(window.__wow)return;window.__wow=1;
var d=document,fine=matchMedia('(hover:hover) and (pointer:fine)').matches;
var END=Date.UTC(2026,11,1,7,59,59);
function el(t,c,h){var e=d.createElement(t);if(c)e.className=c;if(h)e.innerHTML=h;return e}
function pad(n){return n<10?'0'+n:''+n}
function big(e,sz,pos,z,dur,dl){return '<div class="wow-it wow-big" style="--z:'+z+';--sz:'+sz+'px;'+pos+'"><div class="wow-medal" style="animation-duration:'+dur+'s;animation-delay:-'+dl+'s"><i></i><i></i><i></i><i></i><b>'+e+'</b></div></div>'}
function sm(e,sz,pos,z,t,dl,keep){return '<div class="wow-it wow-sm'+(keep?' wow-keep':'')+'" style="--z:'+z+';--sz:'+sz+'px;'+pos+'"><span style="--t:'+t+'s;--dl:'+dl+'s">'+e+'</span></div>'}
function deco(h){
  if(h.querySelector('.wow-deco'))return null;
  var o=el('div','wow-deco');
  var T='🦃',C='🌽',M='🍁',L='🍂',G='🍗',N='🌰';
  o.innerHTML='<i class="wow-beam wow-beam--l"></i><i class="wow-beam wow-beam--l wow-beam--b"></i><i class="wow-beam wow-beam--r"></i><i class="wow-beam wow-beam--r wow-beam--b"></i>'+
    big(T,140,'right:1.4%;top:11%',1,8,0)+big(C,100,'left:1.6%;top:24%',.7,10,3)+
    big(M,84,'left:3.2%;top:56%',.9,9,5)+big(N,80,'right:3.4%;top:46%',.8,11,2)+big(G,92,'right:1.8%;top:72%',.6,9,6)+
    sm(L,34,'left:3%;top:8%',.5,7,0,1)+sm(M,40,'right:3%;top:8%',.7,9,1.2,1)+sm(C,38,'left:5%;top:82%',.9,8,.6)+
    sm(L,30,'right:6%;top:88%',.8,10,2)+sm(L,26,'left:17%;top:6%',.4,6,.3)+sm(M,28,'right:18%;top:6%',.5,8,1.6)+
    sm(N,26,'left:12%;top:90%',.6,7,1)+sm(M,30,'right:12%;top:92%',.5,9,.4);
  h.appendChild(o);return o}
function count(h){
  var b=h.querySelector('.h3__btns');
  if(!b||h.querySelector('.wow-count')||Date.now()>=END)return;
  var c=el('div','wow-count','<p class="wow-count__t">🦃 Thanksgiving sale ends in</p><div class="wow-count__r"><div><b data-u="d">00</b><small>days</small></div><div><b data-u="h">00</b><small>hrs</small></div><div><b data-u="m">00</b><small>min</small></div><div><b data-u="s">00</b><small>sec</small></div></div>');
  b.parentNode.insertBefore(c,b.nextSibling);
  var n={};['d','h','m','s'].forEach(function(k){n[k]=c.querySelector('[data-u='+k+']')});
  function tick(){var t=Math.max(0,END-Date.now())/1000|0;var v={d:t/86400|0,h:t%86400/3600|0,m:t%3600/60|0,s:t%60};for(var k in v){var x=pad(v[k]);if(n[k].textContent!==x)n[k].textContent=x}if(t<=0)c.remove()}
  tick();setInterval(tick,1000)}
function ticker(h){
  var s=h.closest('.shopify-section');
  if(!s||d.querySelector('.wow-tick'))return;
  var it=['🦃 Thanksgiving35 takes 35% off every game','⚡ Keys delivered in minutes','🛡️ Streamproof and tested','🟢 Live safe-to-play status','💬 Real support on Discord','🍂 Sale ends Nov 30'];
  var half=it.map(function(x){return '<span>'+x+'</span>'}).join('');
  s.parentNode.insertBefore(el('div','wow-tick','<div class="wow-tick__track">'+half+half+'</div>'),s.nextSibling)}
function par(h,o){
  if(!fine||!o)return;var f=0,mx=0,my=0;
  function set(){f=0;o.style.setProperty('--mx',mx.toFixed(3));o.style.setProperty('--my',my.toFixed(3))}
  h.addEventListener('pointermove',function(e){var r=h.getBoundingClientRect();mx=(e.clientX-r.left)/r.width*2-1;my=(e.clientY-r.top)/r.height*2-1;if(!f)f=requestAnimationFrame(set)},{passive:true});
  h.addEventListener('pointerleave',function(){mx=0;my=0;if(!f)f=requestAnimationFrame(set)})}
function pause(h,o){
  if(!o||!('IntersectionObserver' in window))return;
  new IntersectionObserver(function(es){o.classList.toggle('wow-off',!es[0].isIntersecting)}).observe(h)}
function glow(){
  if(!fine)return;
  d.addEventListener('pointermove',function(e){
    var c=e.target.closest&&e.target.closest('.e-games a,product-card,.gst__item,.apple-steps__card');
    if(!c)return;
    var s=c.querySelector(':scope>.wow-spot');
    if(!s){if(getComputedStyle(c).position==='static')return;s=el('i','wow-spot');c.appendChild(s)}
    var r=c.getBoundingClientRect();if(!r.width)return;
    s.style.setProperty('--gx',(e.clientX-r.left)+'px');s.style.setProperty('--gy',(e.clientY-r.top)+'px')},{passive:true})}
function cta(){
  if(location.pathname!=='/'||d.querySelector('.wow-cta')||Date.now()>=END)return;
  var a=el('a','wow-cta','<span class="wow-cta__e">🦃</span><span class="wow-cta__t"><b>35% off every game</b><small>Code Thanksgiving35</small></span><span class="wow-cta__b">Shop now</span>');
  a.href='/collections/your-favorite-games';d.body.appendChild(a);d.documentElement.classList.add('wow-cta-on');
  var k=0;function upd(){k=0;a.classList.toggle('is-on',scrollY>innerHeight*.9&&innerHeight+scrollY<d.documentElement.scrollHeight-260)}
  addEventListener('scroll',function(){if(!k)k=requestAnimationFrame(upd)},{passive:true});upd()}
function go(){
  var h=d.querySelector('.h3');
  if(h){var o=deco(h);count(h);ticker(h);par(h,o);pause(h,o)}
  cta();glow()}
if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',go);else go();
})();